import React from 'react';

import { useRouter } from 'next/router';

import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { GUEST_TOKEN } from 'src/utils/constants/localStorageConstants';
import { BreadCrumbsProps } from 'src/utils/constants/TvShowDetailsPageConstants';

import * as styledComponents from './BreadCrumbsStyle';
import { mixpanelObject } from '../../utils/analytics';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_UNIQUE_ID,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_BREADCRUMB
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import { ctaEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../utils/analytics/mixpanel/mixpanelHelper';
import { shouldRedirectToPWA } from '../../utils/cardsUrlGenerator';

const BreadCrumbs = ({ breadCrumbItems }: BreadCrumbsProps) => {
  const router = useRouter();
  const navigationHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const htmlElement = event.target as HTMLAnchorElement;
    const breadCrumbData = htmlElement.dataset.customInfo?.split(',');
    if (breadCrumbData && breadCrumbData.length) {
      clearCtaEventsProperty(mixpanelObject);
      mixpanelObject.setProperty(MIXPANEL_ELEMENT, breadCrumbData[1] || 'N/A');
      mixpanelObject.setProperty(
        MIXPANEL_UNIQUE_ID,
        getLocalStorage(GUEST_TOKEN) || 'N/A'
      );
      mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_BREADCRUMB);
      ctaEvent();
      if (!shouldRedirectToPWA(breadCrumbData[0])) {
        router.push(breadCrumbData[0]);
      } else {
        window.location.assign(breadCrumbData[0]);
      }
    }
  };
  return (
    <styledComponents.CrumbsContainer data-testid="breadCrumbsContainer">
      {breadCrumbItems?.map((breadCrumbItem, index) => {
        return (
          <>
            <styledComponents.BreadCrumbsLink
              href={breadCrumbItem.url}
              data-custom-info={[breadCrumbItem.url, breadCrumbItem.label]}
              onClick={navigationHandler}
              key={index}
              data-testid={`breadCrumbsLink-${index}`}>
              {breadCrumbItem.label}
            </styledComponents.BreadCrumbsLink>
            {index !== breadCrumbItems.length - 1 && (
              <styledComponents.ChevronRight />
            )}
          </>
        );
      })}
    </styledComponents.CrumbsContainer>
  );
};

export default BreadCrumbs;
